import { Button } from '@/components/ui/button';
import { Play, Pause, RotateCcw } from 'lucide-react';

interface LiveTimerProps {
  elapsedSeconds: number;
  isRunning: boolean;
  onToggle: () => void;
  onReset: () => void;
}

function formatTime(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);
  return [h, m, s].map((v) => String(v).padStart(2, '0')).join(':');
}

export function LiveTimer({ elapsedSeconds, isRunning, onToggle, onReset }: LiveTimerProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      <p className="text-sm font-semibold uppercase tracking-widest text-red-400">
        Tiempo sin codear
      </p>

      <div
        className={`
          text-6xl sm:text-7xl md:text-8xl font-mono font-bold tabular-nums tracking-tight
          text-red-500
          ${isRunning ? 'animate-[pulse_2s_ease-in-out_infinite]' : ''}
          drop-shadow-[0_0_24px_rgba(239,68,68,0.4)]
        `}
      >
        {formatTime(elapsedSeconds)}
      </div>

      <div className="flex items-center gap-2 mt-2">
        <Button variant="outline" size="sm" onClick={onToggle} className="gap-2">
          {isRunning ? (
            <>
              <Pause className="w-4 h-4" /> Pausar
            </>
          ) : (
            <>
              <Play className="w-4 h-4" /> Reanudar
            </>
          )}
        </Button>
        <Button variant="ghost" size="sm" onClick={onReset} className="gap-2">
          <RotateCcw className="w-4 h-4" /> Reset
        </Button>
      </div>
    </div>
  );
}
